<template>
  <section v-if="token">
  </section>
</template>
<script>
export default {
  components: {
  },
  props: ["token"],
  data() {
    return {
    };
  },
  methods: {
    async verifyAuthentication() {
      try {
        let result = await this.$http.post(`${this.user.hostname}/authenticate/validate/short-token`,this.token);
        if(result.data.token != ""){
          await this.authenticated(result.data.token, result.data.request_url);
        }else{
          this.$router.push({ name: "Login" }).catch(() => {});
        }
      } catch {
        this.$router.push({ name: "Login" }).catch(() => {});
      }
    },
    async authenticated(token, url) {
      if (token != undefined) {
        this.$cookies.set("token", token, 0);
        await this.$store.dispatch("user/setRedirectUrl", "");
        if(url == ""){
          this.$router.push({ name: "Login" }).catch(() => {});
        }else{
          window.location.href = url;
        }
      }
    }
  },
  mounted: async function () {
    console.log("mounted redirect");
    if (this.token != undefined) {
      this.verifyAuthentication();
    }
  },
};
</script>
<style></style>